<div style="position:relative; z-index: 100; width: 100%;">
<nav class="navbar navbar-expand-md pt-0 " style="position: fixed; width: 100%;">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['']"><img class="lozad" src="assets/img/rev00.png"> </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse ms-md-4" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" [routerLink]="['']">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/about']">About Us</a>`
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/network']">Network</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/digital']">Digital Tribe</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</div>

<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(1).jpg" alt="Image">
          <!-- <h3 class="text-center">Alleviating poverty</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(2).png" alt="image">
          <!-- <h3 class="text-center">Advancing education</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(4).png" alt="Image">
          <!-- <h3 class="text-center">Disaster relief</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(5).png" alt="Image">
          <!-- <h3 class="text-center">Public policy</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(9).png" alt="Image">
          <!-- <h3 class="text-center">Changes in laws</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(6).png" alt="Image">
          <!-- <h3 class="text-center">Societal behavior</h3> -->
        </div>
      </div>
    </div>
  </div>
</section>
<!---END HERO SECTION---->

<!---REVOLUTION SECTION---->

<section>
	<div class="resident  pt-5">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-9 ps-md-0 mb-5">
          <div class="membership-cards">
					<div class="tribe mt-md-5 card mb-5" id="tribe">
						<h2 class="fw-bold">Welcome to Revolution 00 — Where Ownership Begins</h2>
						<p data-aos="fade-up">Revolution 00 was built for us, by us — a digital nation where people of color can thrive without the exploitation, censorship, or chaos found on mainstream platforms. Here, we don’t just talk about change — we’ve built the infrastructure to create it. Whether you're an entrepreneur, student, creator, or community leader, <b>Revolution 00</b> is your space to connect, grow, and circulate wealth within trusted, private digital ecosystems.</p>
            
          <div class="moretext2"  style="display: none">
            <p data-aos="fade-up">We believe in action, not permission. That’s why we’ve created secure tools modeled after some of the most popular online platforms — but reimagined with our communities in mind. For <b>just $9.99 a month</b>, members gain access to livestreaming, webinars, secure messaging, e-commerce, and community-driven tools that support local businesses and mental wellness — all in a gated digital community built for growth, trust, and positivity.</p>

            <h3 class="fw-bold">
              What sets us apart?
            </h3>
            <p> We give back — consistently and intentionally. Every week, we support members with car payments, rent relief, food and gas assistance, HBCU scholarships, youth programs, and free promotion for small businesses. We believe generosity is currency — and that circulating resources within our own communities is how we build long-term strength and security.</p>

  
            <p>Our tech partner, UMYO Wall Street Of Technology, heard our vision and made it a reality — creating everything we needed within weeks, not months. That means we don’t have to worry about complicated tech or high costs each month. They handle the backend as we build our future. Together, we share profits and power that puts culture first and gives leaders the freedom to lead.</p>

            <p>This isn’t just a platform. It’s a revolution in how we engage, earn, support, and rise. So if you're ready to own your presence, amplify your voice, and be part of a community that stands on business — welcome home. <b>Revolution 00</b> is where culture, commerce, and community meet — and where our future begins.</p>

            <h3 class="fw-bold">
              Call-to-Action Section:
            </h3>
            <p> <b>Become a Member for Just $9.99/Month Businesses starts as low as $19.99</b>
                Get access to exclusive tools, weekly giveaways, secure communities, and your own marketplace — all designed with you in mind. Business owners can brand at an affordable cost. Needs additional branding? See our branding packages during registration</p>
                <a style="background-color: black; color: white;" class="btn btn-hover-purple mt-4" href="https://drive.google.com/file/d/1Qhm-Aciui6Qr-cxynBjB1GoDi8nrVS7W/view ">Need More</a>

                <strong> No ads. No algorithms. No exploitation. Just growth, ownership, and opportunity.</strong>

                <ul>
                  <li class="fw-bold">Join the Movement</li>
                  <li class="fw-bold">Explore the Platform</li>
                  <li class="fw-bold">Take the IAM Pledge</li>
                </ul>

            
           
            </div>
            <a  style="background-color: black; color: white;" class="moreless-button2 btn btn-hover-purple border-dark gap-2 mt-4" data-aos="fade-up">
            Read More
            </a>
					</div>
         </div>
				</div>
			</div>
		</div>
	</div>
</section>
<!---END REVOLUTION SECTION---->

<!----POWER SECTION--->
<section id="header" class="power">
       <div class="container-fluid srice py-5">
            <div class="container py-5">
        <h1 class="text-white text-center  mb-3" style="font-weight: 600; ">Revolution00 Members </h1>
        <div class="row">
            <div class="col-lg-5 mt-5">
                <!-- <h4 class="mb-4 text-white">Search For NBA Players Connects Here</h4> -->
                
                          <form [formGroup]="form2" class="text-center">

<div class="row">
                     <div class="col-lg-6 mb-4">
                <input
                  type="name"
                  formControlName="selectedName"
                  class="form-control"
                  placeholder="Name"
                />
              </div>


                

                    <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedBusiness"
                >
                  <option selected value="" disabled>Business Type</option>
                  <option *ngFor="let item of businessType" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

               <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedLocation"
                >
                  <option selected value="" disabled>Location</option>
                  <option *ngFor="let item of location" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

<div class="col-lg-6 mb-4">
                    <input type="text" class="form-control" placeholder="City">
                    </div>
               <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedStateType"
                >
                  <option selected value="" disabled>State</option>
                  <option *ngFor="let item of state" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>


                    
                    

                   
                    <div class="col-lg-6">
                        <h4 class="mb-4 text-white text-center">I Pledge To Report Violent Crimes</h4>
                    </div>

                    <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedRace"
                >
                  <option selected value="" disabled>Race</option>
                  <option *ngFor="let item of race" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              
                    <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedGender"
                >
                  <option selected value="" disabled>Gender</option>
                  <option *ngFor="let item of gender" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
 <div class="col-lg-6 mb-4">
                <input
                  type="name"
                  formControlName="selectedCity"
                  class="form-control"
                  placeholder="City"
                />
              </div>
                    
                   
                    <div class="col-lg-6 mb-4">
                        <button  (click)="searchCards()"
                  [disabled]="!form2.valid" class="btn  text-white py-2 px-5 w-100" style="background: #CC9B2D;">Search</button>
                    </div>   
                </div>

                  </form>


                
                <p class="rounded mb-4 text-white py-2 px-3 my-5 " style="background: #CC9B2D;">Cards</p>
                 <p
              class="text-white mb-4"
              style="cursor: pointer"
              [routerLink]="'/cards/share-card/' + card.id"
              *ngFor="let card of cardsSearched"
            >
              {{ card.cardTitle }}
            </p>
            </div>
            <div class="col-lg-7 mt-5">
             <div class="d-flex position-relative justify-content-center">
              <!-- Nav pills -->
              <div class="element">
                <button                           [class.active]="showLoginTab"
      (click)="checkRoute()" class="btn active">Login</button>
                <button (click)="checkRoute()"
                  [class.active]="!showLoginTab" class="btn">Register</button>
              </div>

              <!-- Tab panes -->
              <div class="tab-content rounded p-4 ">
                
                <!-- Login Tab -->
                <div                 [class.active]="showLoginTab" [class.inactive]="!showLoginTab"
 id="login" class="login">
                  <div class="text-center mb-5">
                    <h1>Revolution 00</h1>
                    <p>Register to Connect with Your Community</p>
                  </div>

                  <h2 class=" mb-3" >Login</h2>

                                  <form [formGroup]="form">
                  <div class="row">
                   <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="email"
                          id="email"
                          class="form-control"
                          formControlName="email"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('email')?.hasError('required') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Email is required.
                        </div>
                        <div
                          *ngIf="
                            form.get('email')?.hasError('email') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Invalid email format.
                        </div>
                      </div>
                    </div>


                    <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >*</sup
                          >
                        </label>
                        <input
                          type="password"
                          id="password"
                          class="form-control"
                          formControlName="password"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('password')?.hasError('required') &&
                            form.get('password')?.touched
                          "
                          class="text-danger"
                        >
                          Password is required.
                        </div>
                      </div>
                      <div class="form-group" style="padding-top: 10px">
                        <label
                          style="
                            font-size: 16px;
                            font-weight: 400;
                            text-decoration: underline;
                            cursor: pointer;
                          "
                          [routerLink]="['/forgot-password']"
                          >Forgot Password?
                        </label>
                      </div>
                    </div>


                    <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                    <div class="text-center">
                      <button       (click)="openAgeModal('login')"
                                        [disabled]="!form.valid" class="btn  text-white py-3 px-5" style="background: #CC9B2D;">Submit</button>
                    </div>
                  </div>

</form>

                </div>

                <!-- Register Tab -->
                <div                 [class.active]="!showLoginTab" [class.inactive]="showLoginTab"
 id="regis" class="register" >
                <form [formGroup]="form3">


                    <div class="text-center mb-5">
                      <h1>Revolution 00</h1>
                    </div>
                    <div class="row text-center mb-5">
                      <div class="col-md-3">
                        <p>Starting at</p>
                        <h1>$9.99</h1>
                        <p>Monthly</p>
                      </div>
                      <div class="col-md-1 d-none d-lg-block">
                        <div style="height: 100%; border-left: 2px solid #ccc;"></div>
                      </div>
                      <div class="col-md-6">
                        <p class="text-start">Includes:</p>
                        <ul class="text-start">
                          <li>40% off all Revolution products</li>
                          <li>3 free property listings per agent</li>
                          <li>Free standard CRM integrations</li>
                        </ul>
                      </div>
                    </div>

                    <h2 class=" mb-4">Register</h2>
                    <div class="row">
                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >First Name
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerFirstName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerFirstName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Last Name
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="text"
                          formControlName="registerLastName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerLastName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Phone Number
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerPhone"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerPhone')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>


                      <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerEmail')?.touched ||
                                !form3.get('registerEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Confirm Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerConfirmEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerConfirmEmail')?.touched ||
                                !form3.get('registerConfirmEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >* </sup
                          ><sup style="color: red; font-size: 14px"
                            >( Length Should be greater than 6 )</sup
                          >
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          required
                          formControlName="registerPassword"
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerPassword')?.touched ||
                                !form3.get('registerPassword')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>



                     <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Gender<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        formControlName="registerGenderType"
                        class="form-select"
                        aria-label="Default select example"
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerGenderType')?.touched ||
                              !form3.get('registerGenderType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of gender" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>


                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Race<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerRaceType')?.touched ||
                              !form3.get('registerRaceType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        class="form-select"
                        aria-label="Default select example"
                        formControlName="registerRaceType"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of race" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >City
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="text"
                          formControlName="registerCityType"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerCityType')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Location<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerLocation')?.touched ||
                              !form3.get('registerLocation')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerLocation"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of location" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    
                     <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Business Type<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerBusiness')?.touched ||
                              !form3.get('registerBusiness')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerBusiness"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option
                          *ngFor="let item of businessType"
                          [value]="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >State<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerStateType')?.touched ||
                              !form3.get('registerStateType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerStateType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option
                          *ngFor="let item of state"
                          [value]="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>

                       


                       


                      <div class="col-md-12 mb-3">
                        <label class="form-label" style="font-size: 18px;">Enter Referral Code </label>
                        <input                           formControlName="registerReferralCode"
 type="text" class="form-control" >
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                      </div>
                    </div>
                    <div (click)="submitForm()" class="text-center">
                      <button      (click)="openAgeModal('signup')"
                      [disabled]="!form3.valid"
                                         type="submit" class="btn  text-white py-3 px-5" style="background: #CC9B2D;">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            </div>
        </div>
    </div>
  </div>
     </section>

<!---END POWER SECTION---->


<!---- CARDS SECTION--->
<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(16).png" alt="Image">
          <!-- <h3 class="text-center">Alleviating poverty</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(17).png" alt="Image">
          <!-- <h3 class="text-center">Advancing education</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(18).png" alt="Image">
          <!-- <h3 class="text-center">Disaster relief</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(13).png" alt="Image">
          <!-- <h3 class="text-center">Public policy</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(11).png" alt="Image">
          <!-- <h3 class="text-center">Changes in laws</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(8).png" alt="Image">
          <!-- <h3 class="text-center">Societal behavior</h3> -->
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(6).png" alt="Image">
          <!-- <h3 class="text-center">Public policy</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(10).png" alt="Image">
          <!-- <h3 class="text-center">Changes in laws</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="revolution_images" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/Website_Images/1(12).png" alt="Image">
          <!-- <h3 class="text-center">Societal behavior</h3> -->
        </div>
      </div>
    </div>
  </div>
</section>

<section id="packages">
  <div class="container">
    <h3>Revolutuion 00 Connects Packages, Products and Platforms</h3>
    <div class="row justify-content-center">
      <div class="col-lg-3 col-md-6">
        <div class="membership-cards h-100" data-aos="zoom-in">
          <div class="card">
          <h2>$75.00 weekly</h2>
          <ul>
            <li>120 Unique Video Cards</li>
            <li>Virtual Touch Screen Coupon</li>
            <li>choose three platform you want free access to - choose three paid platforms you want free access</li>
          </ul>
        </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="membership-cards h-100" data-aos="zoom-in">
        <div class="card">
          <h2>$50 weekly</h2>
          <ul>
            <li>QR Code for Customer Data Collection</li>
            <li>90 Cards</li>
            <li>choose two paid platform you want free access</li>
          </ul>
        </div>
      </div>
    </div>
      <div class="col-lg-3 col-md-6">
        <div class="membership-cards h-100" data-aos="zoom-in">
        <div class="card">
          <h2>$27.50 weekly</h2>
          <ul>
            <li>60 Unique Cards</li>
            <li>QR Code at Business location</li>
            <li>choose one paid platform you want free access</li>
          </ul>
        </div>
      </div>
    </div>
      <div class="col-lg-3 col-md-6">
        <div class="membership-cards h-100" data-aos="zoom-in">
        <div class="card">
          <h2>$12.50 weekly</h2>
          <ul>
            <li>20 Unique Cards</li>
            <li>Branded By Community</li>
            <li class="fw-bold">(residential & business packages)</li>
          </ul>
        </div>
      </div>
    </div>
      <div class="col-md-12">
        <a href="#"  style="background-color: white;" class="btn btn-hover-blue border-dark gap-2 mt-4 mx-auto" data-aos="fade-up">
           Packages
            </a>
      </div>
    </div>
  </div>
</section>


<!----END CARDS SECTION--->

<section class="contact overflow-hidden">
  <div class="container">
        <h1 class="text-center mb-5">Contact Us</h1>
        <div class="row">
          <div class="col-md-6 ">
            <div class="get px-3">
              <h5>Get in Touch</h5>
            <div class="form">
              <input type="text" name="" id="" placeholder="Name"><br>
              <input type="email" name="" id="" placeholder="Email"><br>
              <textarea name="" id="" cols="30" rows="7" placeholder="Message"></textarea><br>
             <div class="select d-flex justify-content-between">
              <input type="file" name="file" id="file" class="inputfile">
              <label  for="file"><i class="fa-solid fa-paperclip "></i>Attach Files</label>
                            <small>Attachments(0)</small>
             </div>
              <button type="submit">SEND MESSAGE</button><br>
              <p class="button-para">This site is protected by reCAPTCHA and the Google <a href="#">Privacy Policy </a>and <a href="#">Terms of Service</a> apply.</p>
            </div>
            </div>
          </div>
          <div class="col-md-6">
           <div class="better px-3">
            <h5>Better yet, see us in person!</h5>
            <p>Get the quickest response by reaching out to us on our social media platforms! You can also contact us directly via phone call or text message. We're excited to engage with you and hear your thoughts!</p>
            <p>Drop us a message, and we'll make it a priority to get back to you at the earliest convenience.</p>
          <button class="whatsapp" type="button"><img src="img/new-icon-removebg-preview.png" alt=""><svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 256 258"><defs><linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#1faf38"/><stop offset="100%" stop-color="#60d669"/></linearGradient><linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#f9f9f9"/><stop offset="100%" stop-color="#fff"/></linearGradient></defs><path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"/><path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"/><path fill="#fff" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64" stroke-width="6.5" stroke="#fff"/></svg> Message us on WhatsApp</button>
          <h4 class="my-4">Revolution00</h4>
          <a class="text-decoration-none" href="#">682-231-2366</a>
          <!-- <a href="#">cmoore@NBA.com</a> -->
          <h4 class="my-4" class="hrs">Hours</h4>
          <select name="" class="timing">
            <option value="">Open 9:00 AM - 9:00 PM</option>
            <option value="">Open 9:00 AM - 9:00 PM</option>
            <option value="">Open 9:00 AM - 9:00 PM</option>
            <option value="">Open 9:00 AM - 9:00 PM</option>
            <option value="">Open 9:00 AM - 9:00 PM</option>
            <option value="">Open 9:00 AM - 9:00 PM</option>
            <option value="">Open 9:00 AM - 9:00 PM</option>
          </select>
           </div>
          </div>
        </div>
      </div>
</section>

<footer>
  <div class="container">
    <h3>Own Your Platform. Build Your Future. Join the Revolution.</h3>
    <h6>A gated digital community created for us — where culture thrives, wealth circulates, and power is shared.</h6>
  </div>
</footer>




<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div class="outerCard" style="min-height: 30vh; cursor: pointer">
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->
          <!-- hide stripe  -->
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button> -->
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="paypalClick()"
          >
            paypal
          </button>
        </div>
        <div *ngIf="selectedPackage?.price == '0'">
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="continuePaymentButton()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ paypalTitleMessage }}</h3>
          <p style="padding-top: 15px">{{ paypalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <form class="checkout-form" [formGroup]="paymentForm">
            <h3>
              Amount
              {{
                selectedPackage?.net_price
                  ? selectedPackage?.net_price
                  : selectedPackage?.price
              }}
            </h3>
            <div class="row">
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-number"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Card Number 16 Digit (Without Dashes)</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-number"
                    data-stripe-element="cardNumber"
                    formControlName="cardNumber"
                    placeholder="XXXXXXXXXXXXXXXX"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-expiry"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Expiration Date in (MM/YY) Format including /
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="card-expiry"
                    data-stripe-element="expiryDate"
                    formControlName="expiryDate"
                    placeholder="MM/YY"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-cvc"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >CVC 3 Digit</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-cvc"
                    data-stripe-element="cvc"
                    formControlName="cvc"
                    placeholder="XXX"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div
                class="col-md-12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding-top: 10px;
                "
              >
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-toggle="modal"
                  id="pay-button"
                  (click)="pay()"
                >
                  Pay Now
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showAgeModal, 'd-block': showAgeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Are You 18+ of your age?</h3>
        </div>
        <p style="padding: 8px">
          You must be at least 13 years old to use the Service. However,
          children of all ages may use the Service and PLTalk Kids (where
          available) if enabled by a parent or legal guardian. Permission by
          Parent or Guardian If you are under 18, you represent that you have
          your parent or guardian’s permission to use the Service. Please have
          them read this Agreement with you. If you are a parent or legal
          guardian of a user under the age of 18, by allowing your child to use
          the Service, you are subject to the terms of this Agreement and
          responsible for your child’s activity on the Service. You can find
          tools and resources to help you manage your family’s experience on
          PLTalk in our Help Center
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirmAge()">
          Yes
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAgeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
